import Spinner from '../spinner';

interface ButtonSpinnerProps {
  isSmall?: boolean;
}

const ButtonSpinner: React.FC<ButtonSpinnerProps> = ({ isSmall = false }) => {
  if (isSmall) {
    return <Spinner size={18} />;
  }

  return (
    <>
      <Spinner size={18} className="sm:hidden" />
      <Spinner size={24} className="hidden sm:block" />
    </>
  );
};

export default ButtonSpinner;
